import React from 'react';

import {Link} from 'react-router';

import {DocumentActionsButton} from 'app/components/general/DocumentActionsButton';
import {ItemWithChildrenStructure} from 'app/general/structures/ItemWithChildrenStructure';
import {KBTreeItemInnerDiv} from 'app/kbs/components/KBEditPage/KBTree/KBTreeStructures';
import {getContentType} from 'app/utils/content-type';

import {DocumentSerializedType} from 'sweet-types';

type Props = {
  document: DocumentSerializedType;
  afterAction: () => Promise<any>;
};
export const DocumentItem = ({document, afterAction}: Props) => {
  const ct = getContentType(document.document_content_type);
  return (
    <ItemWithChildrenStructure
      actionsChildren={
        <DocumentActionsButton
          document={document}
          pageContext="folders"
          refreshData={afterAction}
        />
      }
    >
      <KBTreeItemInnerDiv itemIcon={<i className={ct.icon} />}>
        <div className="flex-grow-1">
          <Link
            to={document.html_url}
            className="text-dark font-weight-bold d-block d-sm-inline"
          >
            {document.name}
          </Link>
        </div>
      </KBTreeItemInnerDiv>
    </ItemWithChildrenStructure>
  );
};
